/**
 * 設定 → マニュアル の外部リンク。pdf は公開の Cloud Storage バケットに置き、差し替えは同じ名前で上書き
 * （URL は変えない）。バケット `salon-dashboard-manuals`（salon-dashboard-452110、公開）は 2026-10-26 作成済み。
 * タスク: githubDOCS/TASKS/2026-10-26_設定にマニュアルのリンクを追加.md
 */
const MANUAL_BASE_URL = 'https://storage.googleapis.com/salon-dashboard-manuals';

export const MANUAL_LINKS = [
  {
    key: 'setup',
    title: '初期設定のマニュアルはこちら',
    desc: 'アカウント登録・目標設定の手順',
    icon: 'checklist',
    url: `${MANUAL_BASE_URL}/setup-manual.pdf`,
  },
  {
    key: 'guide',
    title: '利用ガイドのマニュアルはこちら',
    desc: '各画面の見方・毎日の使い方',
    icon: 'book',
    url: `${MANUAL_BASE_URL}/user-guide.pdf`,
  },
];
